export const OrderConfig = ($stateProvider) => {
  'ngInject';
  $stateProvider.state('app.orderlisting', {
    url: '^/orders',
    template: '<orders-listing></orders-listing>'
  });
  $stateProvider.state('app.orderView', {
    url: '^/order-details-view/:id',
    template: '<order-view></order-view>'
  });
};


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/orders/components/order.config.js
 **/